import(/* webpackMode: "eager" */ "/my-new-one/app/globals.css");
import(/* webpackMode: "eager" */ "/my-new-one/components/sentry-provider.tsx");
import(/* webpackMode: "eager" */ "/my-new-one/components/theme-provider.tsx");
import(/* webpackMode: "eager" */ "/my-new-one/components/ui/toaster.tsx");
import(/* webpackMode: "eager" */ "/my-new-one/components/ui/tooltip.tsx")